<template>
  <div class="about-account">
    <div class="about-account__description">
      Your home inspector uses HomeGauge to manage the inspection process.
      A new HomeGauge account has been created for you which allows you to do the following:
    </div>
    <div class="about-account__points">
      <div v-for="(point) in points" v-bind:key="point" class="point">
      <v-icon class="point__icon">
        check
      </v-icon>
        <div
          v-html="point"
          class="point__text">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      points: [
        'View, sign, and share agreements',
        'Access your report and follow up',
        'Conveniently and securely make payments',
        'Use our innovative CRL<sup>TM</sup> repair list tool',
        'Get exclusive homeowner deals and discounts from HomeGauge',
        '...and more!',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.about-account {
  &__description {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 500;
  }

  &__points {
    margin-top: 25px;
    margin-bottom: 30px;
  }
}

.point {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  &__icon {
    margin-right: 15px;
    color: $theme-color-primary !important;
  }

  &__text {
    font-size: 16px;
    font-weight: 500;
  }
}

@media all and (max-width: 655px) {
  .about-account {
    &__description {
      margin-top: 0;
      font-size: 14px;
    }
  }

  .point {
    &__text {
      font-size: 14px;
    }
  }
}
</style>
